import React, { lazy } from 'react';
import { createRoot } from 'react-dom/client';
import type { INextBookingProps } from './next-booking';

const NextBooking = lazy(async () => import('./next-booking'));

const el = '.fa-component--next-booking';
const DOM = document.querySelector(el);

const render = function () {
    if (DOM) {
        const data = JSON.parse(DOM.getAttribute('data-props')!) as INextBookingProps;

        createRoot(DOM).render(<NextBooking {...data} />);
    }
};

export default {
    render,
};
